<section class="w-full lg:py-25 py-10 bg-[url(/home/vision-bg.png)] bg-no-repeat bg-cover">
  <div class="flex flex-col w-full px-4 lg:px-0 container gap-6 lg:gap-0">
    <!-- 헤더 - 모바일과 PC 레이아웃 분리 -->
    <div class="flex flex-col lg:flex-row lg:justify-between gap-4 lg:items-center">
      <div class="flex flex-col gap-3 text-left">
        <p class="font-extrabold text-sm lg:text-lg text-gradient-primary bg-clip-text text-transparent">VISION</p>
        <h1 class="text-2xl lg:text-4xl lg:leading-14 text-zinc-800">
          혁신과 성장, <span class="font-extrabold">최고의 파트너십</span><br />글로벌 경쟁력의 실현
        </h1>
      </div>

      <p class="text-sm text-zinc-500 font-medium lg:text-lg">
        최고의 마케팅 솔루션으로 고객과 함께 성장하며, 글로벌 스탠다드를 선도하는 최고의 파트너가<br
          class="hidden lg:block" />되겠습니다.
      </p>
    </div>

    <!-- 카드 그리드 -->
    <div class="lg:py-25 grid grid-cols-1 lg:grid-cols-3 gap-3">
      <!-- Vision Card 1 -->
      <div class="relative w-full aspect-video lg:aspect-4/3 rounded-xl overflow-hidden">
        <img src="/home/vision1.png" alt="vision image 1" class="absolute inset-0 w-full h-full object-cover" />
        <div class="absolute inset-0 bg-black/40"></div>
        <div class="absolute inset-0 flex flex-col gap-4 lg:gap-6 items-center justify-center text-white z-10">
          <app-icon name="lsicon:marketing-filled" class="size-6! lg:size-8!" />
          <div class="w-6 lg:w-8 h-0.5 bg-white"></div>
          <div class="flex flex-col gap-2 lg:gap-3 text-center">
            <p class="text-xl lg:text-2xl font-extrabold">Marketing Solution</p>
            <p class="text-xl lg:text-2xl font-bold">마케팅 솔루션</p>
          </div>
        </div>
      </div>

      <!-- Vision Card 2 -->
      <div class="relative w-full aspect-video lg:aspect-4/3 rounded-xl overflow-hidden">
        <img src="/home/vision2.png" alt="vision image 2" class="absolute inset-0 w-full h-full object-cover" />
        <div class="absolute inset-0 bg-black/40"></div>
        <div class="absolute inset-0 flex flex-col gap-4 lg:gap-6 items-center justify-center text-white z-10">
          <app-icon name="material-symbols:partner-exchange-outline-rounded" class="size-6! lg:size-8!" />
          <div class="w-6 lg:w-8 h-0.5 bg-white"></div>
          <div class="flex flex-col gap-2 lg:gap-3 text-center">
            <p class="text-xl lg:text-2xl font-extrabold">Best Partner</p>
            <p class="text-xl lg:text-2xl font-bold">베스트 파트너</p>
          </div>
        </div>
      </div>

      <!-- Vision Card 3 -->
      <div class="relative w-full aspect-video lg:aspect-4/3 rounded-xl overflow-hidden">
        <img src="/home/vision3.png" alt="vision image 3" class="absolute inset-0 w-full h-full object-cover" />
        <div class="absolute inset-0 bg-black/40"></div>
        <div class="absolute inset-0 flex flex-col gap-4 lg:gap-6 items-center justify-center text-white z-10">
          <app-icon name="uil:globe" class="size-6! lg:size-8!" />
          <div class="w-6 lg:w-8 h-0.5 bg-white"></div>
          <div class="flex flex-col gap-2 lg:gap-3 text-center">
            <p class="text-xl lg:text-2xl font-extrabold">Global Standard</p>
            <p class="text-xl lg:text-2xl font-bold">글로벌 스탠다드</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
